export const linkify = (str) => {
  if (!str) return ''
  if (str.includes('href')) return str
  return str.replace(
    /((https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?)/g,
    `<a href="$1" target="_blank">$1</a>`
  )
}

export const unescape = (str) => (str && str
  .replace(/&amp;/g, '&')
  .replace(/&lt;/g, '<')
  .replace(/&gt;/g, '>')
  .replace(/&quot;/g, '"')
  .replace(/&#039;/g, "'")) || ''
